// extracted by mini-css-extract-plugin
module.exports = {"section":"P_section__rI9kW"};